import { Breadcrumbs, Typography, Link, Stack, TablePagination } from "@mui/material";
import { useOrdemCompraConsultarPrecosViewModel } from "../../viewModels/ordem_compra_consultar_precos_view_model";
import { Header } from "./components/header";
import { StyledDataGrid } from "../../../../../common/components/styled_data_grid";
import { useMemo } from "react";
import { GenerateOrdemCompraConsultarPrecosColumnDefinition } from "./columns";
import { OrdemCompraPreco } from "../../../domain/models/ordem_compra_preco";
import { ReportViewerModal } from "../../../../../common/components/report_viewer_modal";
import { PageTopBar, ThreeSlotLayout } from "../../../../../common/components/page_top_bar";
import { ComprasReportModal } from "./components/compras_report_modal";

import AlertError from "../../../../../common/components/alert_error";
import RefreshButton from "../../../../../common/components/refresh_button";
import PrimaryButton from "../../../../../common/components/primary_button";

/**
 * OrdemCompraConsultarPrecos
 */

export const OrdemCompraConsultarPrecos = () => {
  const viewModel = useOrdemCompraConsultarPrecosViewModel();

  const columnsDefinition = useMemo(() => {
    return GenerateOrdemCompraConsultarPrecosColumnDefinition({
    });
  }, [
  ]);

  return (
    <>
      {/**
        * PageTopBar
        */}

      <PageTopBar>
        <ThreeSlotLayout
          rightSlot={
            <div className="flex flex-row gap-2">
              <div className="w-[120px]">
                <PrimaryButton
                  buttonColor="yellow"
                  onMouseDown={e => {
                    viewModel.handleComprasReportModalOpenState(true);
                    e.preventDefault();
                  }}>
                  Relatório
                </PrimaryButton>
              </div>
            </div>
          }
        />
      </PageTopBar>

      {/**
        * Page
        */}

      <div className="flex w-full gap-2 flex-col py-2 px-4 mb-20">
        <Breadcrumbs aria-label="breadcrumb" className="cursor-pointer">
          <Link underline="hover" color="inherit">
            Compras
          </Link>
          <Typography className="text-primary-green">
            Relatório de Compras
          </Typography>
        </Breadcrumbs>

        <div className="flex flex-col gap-2">
          <div className="div flex justify-between items-center flex-col md:flex-row gap-6 md:gap-0">
            <div className="flex gap-2 items-center w-full">
              <h1 className="text-3xl font-medium text-black dark:text-white">Relatório de Compras</h1>
              <RefreshButton onClick={viewModel.handleReload} />
            </div>

            <div className="w-full justify-end flex gap-2">

            </div>
          </div>
        </div>
        {
          viewModel.errorMessage !== undefined
            ? (
              <div className="w-full">
                <AlertError
                  messageErro={viewModel.errorMessage}
                  onTryAgain={viewModel.handleReload} />
              </div>
            ) : (
              <>
                <Header
                  centroCustos={viewModel.filters.centroCustos}
                  titulo={viewModel.filters.titulo}
                  fornecedores={viewModel.filters.fornecedores}
                  dataOrdemCompraDe={viewModel.filters.dataOrdemCompraDe}
                  dataOrdemCompraAte={viewModel.filters.dataOrdemCompraAte}
                  ordemCompras={viewModel.filters.ordemCompras}
                  produtosServicos={viewModel.filters.produtosServicos}
                  dataPagoDe={viewModel.filters.dataPagoDe}
                  dataPagoAte={viewModel.filters.dataPagoAte}
                  subcontas={viewModel.filters.subcontas}
                  statusOC={viewModel.filters.statusOC}
                  centroCustoDropdown={viewModel.centroCustoDropdown}
                  fornecedoresDropdown={viewModel.fornecedoresDropdown}
                  ordemComprasDropdown={viewModel.ordemComprasDropdown}
                  produtoServicosDropdown={viewModel.produtoServicosDropdown}
                  subcontasDropdown={viewModel.subcontasDropdown}
                  onCentroCustosChange={viewModel.handleCentroCustosChange}
                  onTituloChange={viewModel.handleTituloChange}
                  onFornecedoresChange={viewModel.handleFornecedoresChange}
                  onDataOrdemCompraChange={viewModel.handleDataOrdemCompraChange}
                  onOrdemComprasChange={viewModel.handleOrdemComprasChange}
                  onProdutosServicosChange={viewModel.handleProdutosServicosChange}
                  onDataPagoChange={viewModel.handleDataPagoChange}
                  onSubcontasChange={viewModel.handleSubcontasChange}
                  onStatusOCChange={viewModel.handleStatusOCChange}
                  onClearFilters={viewModel.handleClearFilters}
                />

                <div className="w-full flex flex-col gap-2 p-4 bg-light-mode-2 dark:bg-dark-mode-2 rounded border border-border-light-mode dark:border-border-dark-mode text-black dark:text-white">
                  <Stack spacing={0}>
                    <TablePagination
                      component="div"
                      count={viewModel.pagination.totalItems}
                      page={viewModel.pagination.page - 1}
                      rowsPerPageOptions={[10, 25, 50, 100]}
                      rowsPerPage={viewModel.pagination.rowsPerPage}
                      onPageChange={(_, p) => viewModel.handlePageChange(p)}
                      onRowsPerPageChange={(e) => viewModel.handleRowsPerPageChange(parseInt(e.target.value))}
                    />

                    <StyledDataGrid
                      tableName="ordem_compra_consultar_precos"
                      disableColumnMenu={false}
                      getRowHeight={() => 'auto'}
                      getRowId={(row: OrdemCompraPreco) => row.idOrdemCompraProdutoServico}
                      textSize="muitoPequeno"
                      columns={columnsDefinition}
                      loading={viewModel.loading}
                      disableRowSelectionOnClick={true}
                      rows={viewModel.ordemCompraPrecos}
                      rowCount={viewModel.ordemCompraPrecos.length}
                      pageSizeOptions={[10, 25, 50, 100]}
                      paginationMode="server"
                      paginationModel={{
                        page: viewModel.pagination.page,
                        pageSize: viewModel.pagination.rowsPerPage,
                      }}
                    />

                    <TablePagination
                      component="div"
                      count={viewModel.pagination.totalItems}
                      page={viewModel.pagination.page - 1}
                      rowsPerPageOptions={[10, 25, 50, 100]}
                      rowsPerPage={viewModel.pagination.rowsPerPage}
                      onPageChange={(_, p) => viewModel.handlePageChange(p)}
                      onRowsPerPageChange={(e) => viewModel.handleRowsPerPageChange(parseInt(e.target.value))}
                    />

                    {
                      viewModel.ordemCompraTotalValores &&
                      <div className="w-full flex flex-col items-end py-2 px-2 border-t border-border-light-mode dark:border-border-dark-mode">
                        <div className="flex flex-col text-[1.15rem]">
                          <div className="w-[20rem] flex flex-row justify-between">
                            <span>Valor Total: </span>
                            <span className='font-bold text-red-500'>
                              {
                                new Intl.NumberFormat('pt-BR', {
                                  style: 'currency',
                                  currency: 'BRL'
                                }).format(viewModel.ordemCompraTotalValores.valorTotal)
                              }
                            </span>
                          </div>
                          <div className="w-[20rem] flex flex-row justify-between">
                            <span>Quantidade Total: </span>
                            <span className='font-bold text-blue-500'>
                              {
                                new Intl.NumberFormat('pt-BR', {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2
                                }).format(viewModel.ordemCompraTotalValores.quantidadeTotal)
                              }
                            </span>
                          </div>
                        </div>
                      </div>
                    }
                  </Stack>
                </div>
              </>
            )
        }
      </div>

      {/**
        * Modals
        */}

      <ComprasReportModal
        open={viewModel.comprasReportModal}
        saving={viewModel.loading}
        loading={viewModel.loading}
        centroCustoDropdown={viewModel.centroCustoDropdown}
        ordemComprasDropdown={viewModel.ordemComprasDropdown}
        subcontasDropdown={viewModel.subcontasDropdown}
        fornecedoresDropdown={viewModel.fornecedoresDropdown}
        produtoServicosDropdown={viewModel.produtoServicosDropdown}
        onClose={() => viewModel.handleComprasReportModalOpenState(false)}
        onSubmit={viewModel.handleComprasReportModalSubmit}
      />

      <ReportViewerModal
        reportViewerState={viewModel.reportViewerState}
      />
    </>
  )
}